<template>
  <div id='page3' class="page3">
    <div class="realBigTitle"></div>
    <div class="box">
      <nav class="clearfix">
        <div v-if="!news">
          <a href="javascript:;" :class="actives[0]" @click="for_data(0, 1, flag, 0)"><span>최신</span></a>
          <a href="javascript:;" :class="actives[1]" @click="for_data(2, 1, flag, 1)"><span>공지</span></a>
          <a href="javascript:;" :class="actives[2]" @click="for_data(3, 1, flag, 2)"><span>이벤트</span></a>
          <a href="javascript:;" :class="actives[3]" @click="for_data(1, 1, flag, 3)"><span>공략</span></a>
        </div>
        <div v-else class="data">
          <!-- '게임특징', '게임소개', 'FAQ' -->
          <a href="javascript:;" :class="actives[0]" @click="for_data(4, 1, flag, 0)"><span>게임특징</span></a>
          <a href="javascript:;" :class="actives[1]" @click="for_data(5, 1, flag, 1)"><span>게임소개</span></a>
          <a href="javascript:;" :class="actives[2]" @click="for_data(6, 1, flag, 2)"><span>FAQ</span></a>
        </div>
      </nav>
      <div class="main">
        <div class="main-notice" :class="notice">
          <div class="title" v-if="model">{{title}}</div>
          <div class="notice">
            <ul class="list" >
              <li v-for="(list, index) in listing" :key="index" @click="click_list(list.id)"><span class="list-title" v-show="notice === 'active'">{{list.type}}</span><a href="javascript:;"><span>{{list.title}}</span><span class="date">{{list.date}}</span></a></li>
            </ul>
            <!-- <li @click="list(id)"><span class="list-title">1</span><a href="javascript:;">fuck<span>2018-02-14</span></a></li> -->
          </div>
        </div>
        <div class="main-content" :class="contents" v-for="(text, index) in text" :key="index">
          <div class="list-title"><span>{{text.type}}</span><h3 class="title">{{text.title}}<span>{{text.date}}</span></h3></div>
          <div class="content" id="content" v-html="text.content"></div>
          <div class="return-title" @click="for_data(type, currentOne)"><a href="javascript:;">&lt;&lt;<span>Back</span></a></div>
        </div>
          <ul class="pageing clearfix" v-if="pageing">
            <li @click="current-- && goto(current)" class="left-btn"><span></span>이전 페이지</li>
            <li class="pageingA">
              <template v-if="model">
                <a href="javascript:;" v-for="index in paging" @click="goto(index)" :class="{'active':current == index}" :key="index">{{index}}</a>
              </template>
            </li>
            <li @click="current++ && goto(current++)" class="right-btn">다음 페이지<span></span></li>
        </ul>
        <div class="model-select" v-if="!model">
          <a href="javascript:;" class="news" :class="{'active': !modelNews}" @click="model_switch(false, 0, flag, 0)"></a>
          <a href="javascript:;" class="data" :class="{'active': modelNews}" @click="model_switch(true ,4, flag, 0)"></a>
        </div>
      </div>
    </div>
    <template  v-if="!model">
      <div class="content-mb" :class="contents" v-for="(text, index) in text" :key="index">
        <div class="mb-box" id="mb-box">
            <div class="list-title"><span>{{text.type}}</span><h3 class="title"><p>{{text.title}}</p><span>{{text.date}}</span></h3></div>
            <div class="content" id="contens" v-html="text.content"></div>
            <div class="return-title" @click="for_data(type, currentOne, flag, z)"><a href="javascript:;">&lt;&lt;<span>Back</span></a></div>
        </div>
      </div>
    </template>
    <footers v-if="footer"></footers>
  </div>
</template>

<script>
import footers from '@/components/footers.vue'
export default {
  name: 'page3',
  data () {
    return {
      id: 1,
      notice: 'active',
      contents: '',
      text: '',
      actives: ['active', '', '', ''],
      paging: [],
      listing: [],
      title: '',
      current: '',
      currentOne: '',
      showItem: 7,
      allpage: '',
      pageing: false,
      type: 0,
      typeName: ['최신', '공지', '이벤트', '공략', '게임특징', '게임소개', 'FAQ'],
      model: true,
      modelNews: false,
      news: false,
      flag: false,
      z: '',
      footer: true
    }
  },
  components: {
    footers: footers
  },
  methods: {
    getType (val) {
      switch (val) {
        case '攻略':
          return this.typeName[3]
        case '活动':
          return this.typeName[2]
        case '公告':
          return this.typeName[1]
        case '游戏特色':
          return this.typeName[4]
        case '游戏介绍':
          return this.typeName[5]
        case 'FAQ':
          return this.typeName[6]
        default:
          return ''
      }
    },
    for_data (type, page, flag, index) {
      this.current = page
      this.currentOne = page
      this.footer = true
      this.model ? this.showItem = 7 : this.showItem = 6
      this.z = index
      let title = ['최신', '공지', '이벤트', '공략', '게임특징', '게임소개', 'FAQ']
      if (index !== undefined) {
        this.title = title[index]
      }
      this.text = []
      const sendType = ['', '攻略', '公告', '活动']
      this.$http.get(`${this.$NODE_BASEURL}/article?project_id=${this.$NODE_PROJECTID}${sendType[type] ? '&type=' + sendType[type] : ''}&page=${page}&pageSize=${this.showItem}`).then(response => {
        const res = response.data
        this.listing = []
        this.allpage = Math.ceil(res.total / this.showItem)
        this.paging = this.pages()
        this.listing = res.list.map(item => {
          return { id: item.id, type: this.getType(item.type), title: item.title, date: item.published_at.slice(0, 10) }
        })
        this.pageing = true
        flag ? this.notice = 'active datas' : this.notice = 'active'
      })
      let content = document.getElementById('content')
      // 删除监听事件
      if (content !== null) {
        setTimeout(() => {
          content.removeEventListener('touchmove', function (event) {
            event.preventDefault()
          }, false)
        }, 1000)
      }
      this.notice = 'active'
      this.contents = ''
      if (index === '' || index === undefined) return
      for (let i in this.actives) {
        this.actives[i] = ''
        this.actives[index] = 'active'
        this.$set(this.actives, i, this.actives[i])
      }
    },
    click_list: function (id) {
      this.footer = false
      this.$lib.IsPC() && (this.pageing = false)
      this.$http.get(`${this.$NODE_BASEURL}/article?project_id=${this.$NODE_PROJECTID}&id=${id}`).then(response => {
        const res = response.data
        this.text = []
        this.text = res.list.map(item => {
          return { title: item.title, content: item.content, date: item.published_at.slice(0, 10), type: this.getType(item.type) }
        })
        this.notice = ''
        this.type >= 4 ? this.contents = 'active data' : this.contents = 'active'
        this.$nextTick(() => {
          // 监听事件，并且阻止事件冒泡
          if (this.$lib.IsPC()) {
            let content = document.getElementById('content')
            content.addEventListener('mousewheel', function (event) {
              event.stopPropagation()
            }, false)
          } else {
            let mb = document.getElementById('mb-box')
            mb.addEventListener('touchmove', function (event) {
              event.stopPropagation()
            }, false)
            mb.addEventListener('touchstart', function (event) {
              event.stopPropagation()
            }, false)
            mb.addEventListener('touchend', function (event) {
              event.stopPropagation()
            }, false)
          }
        })
      })
    },
    pages: function () {
      let pag = []
      if (this.current < this.showItem) { // 如果当前的激活的项 小于要显示的条数
        // 总页数和要显示的条数那个大就显示多少条
        let i = Math.min(this.showItem, this.allpage)
        while (i) {
          pag.unshift(i--)
        }
      } else { // 当前页数大于显示页数了
        let middle = this.current - Math.floor(this.showItem / 2) // 从哪里开始
        let i = this.showItem
        if (middle > (this.allpage - this.showItem)) {
          middle = (this.allpage - this.showItem) + 1
        }
        while (i--) {
          pag.push(middle++)
        }
      }
      return pag
    },
    goto: function (index) {
      let that = this
      let a = that.currentOne
      if (index === 0) {
        that.current = 1
      } else if (index === a) {
      } else if (index > that.allpage) {
        that.current = index - 1
      } else {
        that.current = index
        that.for_data(that.type, index)
      }
      // 这里可以发送ajax请求
    },
    model_switch: function (flag, page) {
      this.modelNews = flag
      this.news = flag
      this.flag = flag
      this.for_data(page, 1, flag, 0)
    }
  },
  mounted: function () {
    // page3 mounted
    if (!this.$lib.IsPC()) {
      this.model = false
    }
    this.for_data(0, 1, this.flag, 0)
    this.$lib.addC4M('page3', 'page3-mobile')
    this.$lib.addC4Mac('page3', 'page3-Mac')
    this.$lib.addC4iPad('page3', 'page3-iPad')
    console.log(this.showItem)
  }
}
</script>

<style type="text/scss" lang="scss">
#page3{
  .box{
    .main{
      .main-content{
        .content{
          *{
            text-align: justify !important;
          }
          p{
            font-size: 14px !important;
          }
          img{
            max-width: 100%;
            width: auto !important;
            height: auto !important;
          }
          iframe{
            width: 100% !important;
          }
        }
      }
    }
  }
  &.page3-mobile {
    .content-mb{
      .content{
        *{
          font-size: .23rem !important;
        }
        img{
          width: auto !important;
          max-width: 100%;
        }
        iframe{
          width: 100% !important;
          // height: 100% !important;
          height: 3.8rem !important;
        }
      }
    }
  }
  &.page3-iPad{
    .content-mb{
      .content{
        *{
          line-height: 1.5;
        }
      }
    }
  }
}
// #page3 .box .main .main-content .content
</style>
<style type="text/scss" lang="scss" scoped>
#page3 {
  //begin you code
  background: url("../assets/images/index/bg/s3-bg.jpg") center top no-repeat;
  .realBigTitle {
    position: absolute;
    top: 60px;
    left: 50%;
    transform: translateX(-50%);
    width: 330px;
    height: 140px;
    background: url("../assets/images/index/bg/s3-bg-title.png") center top no-repeat;
    background-size: contain;
  }
  .box{
    width: 1327px;
    height: 601px;
    margin: 0 auto ;
    position: absolute;
    left: 50%;
    top: 254px;
    transform: translateX(-50%);
    nav a{
      width: 301px;
      height: 168px;
      position: absolute;
      // transition: all .5s;
      z-index: 2;
      span{
        display: block;
        width: 100%;
        height: 100%;
        opacity: 0;
        // transition:  all .5s;
        color: transparent;
      }
      &:nth-of-type(1){
        top: 111px;
        left: 0;
        background: url(../assets/images/index/page3/s3-btn01.png)no-repeat center;
        background-size: contain;
        span{
          background: url(../assets/images/index/page3/s3-btn01-hover-txt.png)no-repeat center 80px;
          background-size: 170px;
        }
        &.active{
          background: url(../assets/images/index/page3/s3-btn-hover01.png)no-repeat center;
          background-size: contain;
          span{
            opacity: 1;
          }
        }
      }
      &:nth-of-type(2){
        top: 275px;
        left: 0;
        background: url(../assets/images/index/page3/s3-btn02.png)no-repeat center;
        background-size: contain;
        span{
          background: url(../assets/images/index/page3/s3-btn02-hover-txt.png)no-repeat center 30px;
          background-size: 170px;
        }
        &.active{
          background: url(../assets/images/index/page3/s3-btn-hover02.png)no-repeat center;
          background-size: contain;
          span{
            opacity: 1;
          }
        }
      }
      &:nth-of-type(3){
        top: 111px;
        right: 0;
        background: url(../assets/images/index/page3/s3-btn03.png)no-repeat center;
        background-size: contain;
        span{
          background: url(../assets/images/index/page3/s3-btn03-hover-txt.png)no-repeat center 80px;
          background-size: 170px;
        }
        &.active{
          background: url(../assets/images/index/page3/s3-btn-hover01.png)no-repeat center;
          background-size: contain;
          span{
            opacity: 1;
          }
        }
      }
      &:nth-of-type(4){
        top: 275px;
        right: 0;
        background: url(../assets/images/index/page3/s3-btn04.png)no-repeat center;
        background-size: contain;
        span{
          background: url(../assets/images/index/page3/s3-btn04-hover-txt.png)no-repeat center 30px;
          background-size: 170px;
        }
        &.active{
          background: url(../assets/images/index/page3/s3-btn-hover02.png)no-repeat center;
          background-size: contain;
          span{
            opacity: 1;
          }
        }
      }
      @media screen and (min-width:1200px){
        &{
          width: 332px;
          &:nth-of-type(1):hover{
            background: url(../assets/images/index/page3/s3-btn-hover01.png)no-repeat center;
            background-size: contain;
            span{
              opacity: 1;
            }
          }
          &:nth-of-type(2):hover{
            background: url(../assets/images/index/page3/s3-btn-hover02.png)no-repeat center;
            background-size: contain;
            span{
              opacity: 1;
            }
          }
          &:nth-of-type(3):hover{
            background: url(../assets/images/index/page3/s3-btn-hover01.png)no-repeat center;
            background-size: contain;
            span{
              opacity: 1;
            }
          }
          &:nth-of-type(4):hover{
            background: url(../assets/images/index/page3/s3-btn-hover02.png)no-repeat center;
            background-size: contain;
            span{
              opacity: 1;
            }
          }
        }
      }
    }
    .main{
      position: relative;
      .main-notice{
        width: 0;
        height: 0;
        margin: 0 auto;
        opacity: 0;
        transition: all .5s;
        overflow:hidden;
        &.active{
          width: 650px;
          opacity: 1;
          height: 550px;
        }
        .title{
          background: url(../assets/images/index/page3/list-bg.jpg)no-repeat;
          height: 50px;
          width: 100%;
          font-size: 30px;
          color: #fff;
          text-shadow: 3px 3px 4px rgba(0, 0, 0, .75);
          line-height: 50px;
          text-align: center;
        }
        .notice{
          height: 500px;
          // background: #fff0cc;
          background: rgba(6,6,6,.95);
          padding-top: 30px;
          .list{
            width: 600px;
            margin: 0 auto;
            li{
              height: 50px;
              line-height: 50px;
              padding-left: 6px;
              position: relative;
              &:not(:last-child){
                margin-bottom: 15px;
              }
              &:before{
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;
                right: 0;
                background: url(../assets/images/index/page3/list-hover.png);
                background-size: contain;
                opacity: 0;
                transition:  all .5s;
              }
              .list-title{
                height: 35px;
                width: 60px;
                font-size:14px;
                display: inline-block;
                background: #fff1d1;
                text-align: center;
                line-height: 35px;
                vertical-align: middle;
                border: 1px solid #fff1d1;
                transition: all .5s;
              }
              a{
                display: inline-block;
                height: 35px;
                width: 510px;
                margin-left: 18px;
                border-bottom: 1px solid rgba(255,255,255,.5);
                color: #fff;
                line-height: 35px;
                vertical-align: middle;
                span{
                  &.date{
                    position: absolute;
                    right: 0;
                    top: 50%;
                    color: #fdefcb;
                    transform: translateY(-50%);
                  }
                }
              }
              .list-title,a{
                position: relative;
              }
              @media screen and (min-width:1200px){
                &:hover{
                  &:before{
                    opacity: .5;
                  }
                  .list-title{
                    border: 1px solid #fee099;
                    background: #fee099;
                  }
                }
              }
            }
          }
        }
      }
      .main-content{
        width: 0;
        height: 0;
        margin: 0 auto;
        background: #000;
        overflow: hidden;
        opacity: 0;
        transition: all .5s;
        color: #fff;
        &.active{
          width: 650px;
          height: 550px;
          opacity: 1;
          margin: 0 auto 22px;
          padding-top: 15px;
          padding-bottom: 25px;
        }
        .list-title{
          width: 594px;
          margin: 0 auto 22px;
          &>span{
            display: inline-block;
            vertical-align: middle;
            width: 60px;
            height: 35px;
            line-height: 35px;
            color: #000;
            text-align: center;
            background: #fee298;
            font-size: 16px;
          }
          .title{
            display: inline-block;
            vertical-align: middle;
            height: 35px;
            line-height: 35px;
            border-bottom: 1px solid rgba(255,255,255,.5);
            width: 510px;
            margin-left: 19px;
            position: relative;
            color: #c00e0e;
            font-size: 16px;
            span{
              position: absolute;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
              color: #fff0cc;
              font-size: 12px;
            }
          }
        }
        .content{
          width: 594px;
          margin: 0 auto;
          height: 432px;
          overflow: auto;
          padding-right: 10px;
          /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
          &::-webkit-scrollbar{
            width: 8px;
            height: 0;
            background-color: #F5F5F5;
          }
          /*定义滚动条轨道 内阴影+圆角*/
          &::-webkit-scrollbar-track{
            -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
            background-color: #ccc;
          }
          /*定义滑块 内阴影+圆角*/
          &::-webkit-scrollbar-thumb{
            -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
            background-color: #393939;
          }
        }
        .return-title{
          width: 594px;
          margin: 0 auto;
          a{
            font-size: 14px;
            color: #ffd571;
            span{
              margin-left:10px
            }
          }
        }
      }
      .pageing{
        width: 464px;
        margin: 0 auto;
        text-align: center;
        li,a{
          display: inline-block;
          vertical-align: middle;
        }
        .left-btn{
          font-size: 0;
          border-top: 15px solid transparent;
          border-bottom: 15px solid transparent;
          border-right: 15px solid #ffe7b4;
          margin-right: 60px;
          @media screen and (min-width:1200px) {
            &:hover{
              border-right: 15px solid #fff;
            }
          }
        }
        .right-btn{
          font-size: 0;
          border-top: 15px solid transparent;
          border-bottom: 15px solid transparent;
          border-left: 15px solid #ffe7b4;
          margin-left: 60px;
          @media screen and (min-width:1200px) {
            &:hover{
            border-left: 15px solid #fff;
            }
          }
        }
        .pageingA{
          width: 304px;
          a{
            color: #fff;
            font-size: 20px;
            height: 25px;
            width: 25px;
            line-height: 25px;
            text-align:center;
            border: 1px solid transparent;
            border-radius: 90px;
            transition: all .5s;
            &:not(:last-child){
              margin-right: 44px;
            }
            &.active{
              background: #ffe6b6;
              color: #000;
            }
            @media screen and (min-width:1200px) {
              &:hover{
                background: #ffe6b6;
                color: #000;
              }
            }
          }
        }
      }
    }
  }
  &.page3-Mac{
    .realBigTitle{
      transform: translateX(-50%) scale(.7);
    }
    .box{
      top: 130px;
      transform: translateX(-50%) scale(.8);
    }
  }
  &.page3-mobile {
    // s3-bg.jpg
    background: url("../assets/images/index-mb/bg/s3-bg.jpg") center top no-repeat;
    background-size: 100% auto;
    height: 11.2rem;
    position: relative;
    .realBigTitle {
      // display: none;
      position: absolute;
      top: 1.30rem;
      left: 50%;
      transform: translateX(-50%) scale(.7);
      width: 7.68rem;
      height: 2.00rem;
      background: url("../assets/images/index-mb/bg/s3-title.png") center top no-repeat;
      background-size: contain;
    }
    .box{
      width: 7.08rem;
      top: 3rem;
      height: 6.6rem;
      nav{
        background: url(../assets/images/index-mb/page3/list-bg.jpg)no-repeat;
        background-size: 100% auto;
        height: .95rem;
        a{
          position: relative;
          width: 1.7rem;
          background: transparent;
          height: 100%;
          float:left;
          width: 25%;
          top: 0;
          text-align: center;
          vertical-align: middle;
          //background: #fff;
          font-size: .34rem;
          &:nth-of-type(1),
          &:nth-of-type(2),
          &:nth-of-type(3),
          &:nth-of-type(4){
            span{
              background: transparent;
              opacity: 1;
              line-height: .95rem;
              color: #fff;
            }
          }
          &.active{
            background: transparent;
            &:after{
              position: absolute;
              content: '';
              top: 0;
              left: 0;
              width: 100%;
              height: .06rem;
              background: #f00214;
            }
          }
        }
        .data{
          a{
            width: 33.33%;
          }
        }
      }
      .main{
        .main-notice{
          width: 100%;
          height: 0;
          transition: all 0s;
          .notice{
            padding-top: .36rem;
            height: 0;
            .list{
              width: 6.1rem;
              li{
                margin-bottom: .2rem;
                &:last-child{
                  margin-bottom: 0;
                }
                .list-title{
                  width: .76rem;
                  height: .36rem;
                  font-size: .15rem;
                }
                a{
                  width: 5.19rem;
                  margin-left: .06rem;
                  font-size: .24rem;
                  span{
                    &:nth-of-type(1){
                      display:inline-block;
                      width: 3.85rem;
                      overflow: hidden;
                      text-overflow:ellipsis;
                      white-space:nowrap;
                    }
                  }
                }
              }
            }
          }
          &.datas{
            .notice{
              .list{
                li{
                  .list-title{
                    display: none;
                  }
                  a{
                    width: 6.1rem;
                    margin-left: 0;
                  }
                }
              }
            }
          }
          &.active{
            margin-bottom: .1rem;
            height: 4.5rem;
            .notice{
              height: 100%;
            }
          }
        }
        .main-content{
          &.active{
          }
        }
        .pageing{
          width: 6.12rem;
          height: .47rem;
          overflow: hidden;
          color: #bbb;
          position: relative;
          margin-bottom: .36rem;
          .right-btn,.left-btn{
            position:absolute;
            font-size:.24rem;
            width: 1.63rem;
            border: none;
            top:0;
          }
          .left-btn{
            left:0;
            margin-right: 0;
            span{
              display: inline-block;
              vertical-align: middle;
              border-top: .24rem solid transparent;
              border-bottom: .24rem solid transparent;
              border-right: .24rem solid #ffe7b4;
              margin-right: .19rem;
            }
          }
          .right-btn{
            right:0;
            margin-left: 0;
            span{
              display: inline-block;
              vertical-align: middle;
              border-top: .24rem solid transparent;
              border-bottom: .24rem solid transparent;
              border-left: .24rem solid #ffe7b4;
              margin-left: .19rem;
            }
          }
        }
        .model-select{
          width: 4.86rem;
          height: 1.25rem;
          margin: 0 auto;
          padding: .24rem .25rem;
          background: url(../assets/images/index-mb/page3/section3-btn-bg.png)no-repeat;
          background-size: 100%;
          .news,.data{
            width: 1.86rem;
            height: 100%;
          }
          .news{
            float: left;
            background: url(../assets/images/index-mb/page3/section3-btn01.png)no-repeat;
            background-size: 100%;
            &.active{
              background: url(../assets/images/index-mb/page3/section3-btn01-hover.png)no-repeat;
              background-size: 100%;
            }
          }
          .data{
            float: right;
            background: url(../assets/images/index-mb/page3/section3-btn02.png)no-repeat;
            background-size: 100%;
            &.active{
              background: url(../assets/images/index-mb/page3/section3-btn02-hover.png)no-repeat;
              background-size: 100%;
            }
          }
        }
      }
    }
    .content-mb{
      position: absolute;
      left: 0;
      right: 0;
      top: .95rem;
      bottom: 0;
      background: #010101;
      color: #cbcbcb;
      .mb-box{
        width: 6.73rem;
        height: 10rem;
        margin: 0 auto;
        padding-top: .38rem;
        position: relative;
        padding-bottom: .27rem;
        .list-title{
          font-size: .18rem;
          border-bottom: .01rem solid #808080;
          padding-bottom: .09rem;
          margin-bottom: .28rem;
          &>span{
            height: .36rem;
            width: .75rem;
            display: inline-block;
            vertical-align: middle;
            text-align: center;
            line-height: .36rem;
            background: #fbe597;
            color: #4f3515;
            margin-right: .08rem;
          }
          .title{
            display: inline-block;
            vertical-align: middle;
            width: 5.9rem;
            position: relative;
            p{
              width: 4.48rem;
            }
            span{
              position: absolute;
              right:0;
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }
      }
      .content{
        font-size: .23rem !important;
        margin-bottom: .27rem;
        height: 8.5rem;
        overflow-y: auto;
        overflow-x:hidden;
      }
      .return-title{
        a{
          font-size: .21rem;
          color: #ffd571;
          span{
            margin-left: .14rem;
            display: inline-block;
            vertical-align: middle;
          }
        }
      }
      &.data{
        .mb-box{
          .list-title{
            width: 6.75rem;
            .title{
              width: 100%;
            }
          }
        }
      }
    }
  }
  &.page3-iPad{
    height: 9.2rem;
    .box{
      top: 2.3rem;
      // trnasfro
      transform: translateX(-50%) scale(.8);
      &>nav{
          a{
            &:hover{
              background:transparent !important;
              span{
                background:transparent !important;
              }
            }
            &.active{
              background:transparent !important;
            }
          }
        }
      .main{
        .main-notice{
          &.active{
            height: 4rem;
          }
          .list{
            li{
              height: .4rem;
              line-height: .4rem;
              .list-title{
                line-height: .36rem;
              }
              a{
                height: .36rem;
                line-height: .36rem;
              }
            }
          }
        }
      }
    }
    .content-mb{
      .mb-box{
        .list-title{
          font-size: .16rem;
        }
      }
      .content{
        height: 6.5rem;
        margin-bottom: .15rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/index/page3.vue